import { buttonProps } from '@components/atoms/Button/props/default';
import checkboxStyle from '@components/atoms/Checkbox/styles/default';
import dropdownStyle from '@components/atoms/Dropdown/styles/bordered';
import inputStyle from '@components/atoms/Input/styles/bordered';
import { Spinner } from '@components/atoms/Spinner/Spinner';
import type { CreateUserFormProps as CreateUserFormPropsDefault } from '@vgn-medien-holding/vgn-fe-components';
import { composeStyles, CreateUserForm as DefaultCreateUserForm } from '@vgn-medien-holding/vgn-fe-components';
import formStyle from './styles/default';

const TERMS_URL = 'https://files.fairu.app/508b7bdf-e88e-416a-acfb-f11a0a36479f/VGN_AGB_2021_03042026.pdf';

export interface CreateUserFormProps extends Omit<CreateUserFormPropsDefault, 'initialState'> {
  onBackAction: () => void;
}

export function CreateUserForm({
  classProps,
  submitHandler,
  onBackAction,
  isLoading,
  subscriberProps,
  infoSubscription,
}: CreateUserFormProps & { isLoading?: boolean }) {
  return (
    <DefaultCreateUserForm
      classProps={composeStyles(formStyle, classProps)}
      checkboxClassProps={checkboxStyle}
      inputClassProps={inputStyle}
      initialState={{
        firstName: '',
        lastName: '',
        gender: '',
        conditions: false,
      }}
      dropdownProps={{ classProps: dropdownStyle }}
      submitHandler={submitHandler}
      buttonProps={{ ...buttonProps.primary, text: 'Weiter' }}
      buttonBackProps={{
        ...buttonProps.secondary,
        text: 'Zurück',
        onAction: onBackAction,
        PreElement: isLoading && <Spinner iconSize="1em" />,
      }}
      genderExcludes={['company', 'family']}
      subscriberProps={subscriberProps}
      infoSubscription={infoSubscription}
      conditionsProps={{
        id: 'conditions',
        label: (
          <>
            Ich akzeptiere die{' '}
            <a href={TERMS_URL} target="_blank" rel="noopener noreferrer" className="underline">
              allgemeinen Geschäftsbedingungen
            </a>
            *
          </>
        ),
      }}
    />
  );
}
